export default __webpack_public_path__ + "static/media/Pencil.3eb1074b.svg";